import type { ReportWidgetColumnConfig } from '../../model/types';

interface HeaderCellSize {
    width?: string;
    minWidth?: string;
    maxWidth?: string;
}

function px(value: number | undefined): string | undefined {
    return value == null ? undefined : `${value}px`;
}

export function lockedColumnWidth(
    column: ReportWidgetColumnConfig,
): number | undefined {
    if (column.minWidth == null || column.minWidth !== column.maxWidth) {
        return undefined;
    }
    return column.minWidth;
}

export function getHeaderCellSize(params: {
    column: ReportWidgetColumnConfig;
    measuredWidth?: number;
    isPrinting: boolean;
}): HeaderCellSize {
    const { column, measuredWidth, isPrinting } = params;
    if (isPrinting) {
        return {};
    }

    const locked = lockedColumnWidth(column);
    if (locked != null) {
        const size = px(locked);
        return { width: size, minWidth: size, maxWidth: size };
    }

    return {
        width: px(measuredWidth),
        minWidth: px(measuredWidth ?? column.minWidth),
        maxWidth: px(measuredWidth ?? column.maxWidth),
    };
}
